import React from 'react';
import TableCell from "@material-ui/core/TableCell";
import {useStyles} from "../cpManagementDataTableStyle";
import '../styles.scss'

function Index(props) {
  const {row, value, className = '', onClick, children} = props;
  const classes = useStyles();
  return (
    children ?
      <TableCell className={[classes.tableCell, className]}>{props.children}</TableCell> :
      (<TableCell
        className={[classes.tableCell, className]}
        onClick={() => {
          onClick && onClick(row)
        }}>
        {value}
      </TableCell>)
  );
}

export default Index;
